import React, { useState, useRef } from "react";
import AuthInput from "../../shared/authinput";
import HorizontalLine from "../../shared/HorizontalLine";
import { Container } from "@mui/material";
import MainButton from "../../shared/Button";
import { Formik, Form, Field, ErrorMessage } from "formik";
import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { isValidPhoneNumber } from "react-phone-number-input";
import {
  PhoneInputsMain,
  CustomLabel,
} from "../../shared/commonstyle/PhoneStyle";
import { OrText } from "../../shared/commonstyle/AuthStyle";
import CommonPhoneInputs from "../../shared/authinput/CommonPhoneInputs";
import { getCountryCallingCode } from "react-phone-number-input";
import { SIGNIN } from "../../../constants/apiEndPoints";
import httpRequest from "../../../axios/index";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../../redux/slice/user/UserSlice";
import { LoginvalidationSchema } from "../../../helpers/validations/Auth";
import { ForgotPassword } from "./styles/LoginStyle";
import {
  handleFacebookLogin,
  HandleGoogleLogin,
  SocialLoginApi,
} from "../../../services/auth/SocialLogin";
import OAuthButton from "../../shared/oauthbutton";
import facebookIcon from "../../../assets/images/facebookicon.svg";
import GoogleIcon from "../../../assets/images/GoogleIcon.svg";

const Login = () => {
  const dispatch = useDispatch();
  const PhoneInputFoucs = useRef(null);
  const defaultCountryCode = "US";
  const navigate = useNavigate();
  const [Loading, setLoading] = useState(false);
  const [PhoneError, SetPhoneError] = useState(false);
  const [IsItEmail, SetIsEmail] = useState(true);
  const [isLoadingGoogle, setIsLoadingGoogle] = useState(false);
  const [isLoadingFacebook, setIsLoadingFacebook] = useState(false);

  const handleChange = (value, event, form) => {
    SetPhoneError(false);
    if (event?.nativeEvent?.inputType === "deleteContentBackward" && !value) {
      event.preventDefault();
      return;
    }
    const isNonString = typeof value !== "string";
    if (isNonString || value === "") {
      form.setFieldValue("phoneNumber", value);
      form.setFieldError("phoneNumber", "");
    } else {
      const isValid = isValidPhoneNumber(value);
      form.setFieldValue("phoneNumber", value);
      form.setFieldError(
        "phoneNumber",
        isValid ? undefined : "Invalid phone number"
      );
    }
    const digitCount = value?.replace(/\D/g, "")?.length;
    if (digitCount !== undefined && digitCount === 1) {
      SetIsEmail(true);
      form.setFieldValue("IsEmail", digitCount);
    } else if (value === "" || value === undefined) {
      form.setFieldValue("IsEmail", "");
      SetIsEmail(true);
    }
  };

  const EmailOnChange = (value, form) => {
    form.setFieldValue("IsEmail", value);
    if (/^\d+$/.test(value) && value.length >= 2) {
      SetIsEmail(false);
      const phoneNumberValues = `+${getCountryCallingCode(
        defaultCountryCode
      )}${value}`;
      form.setFieldValue("phoneNumber", phoneNumberValues);
      form.setFieldValue("IsEmail", " ");
    } else {
      SetIsEmail(true);
      form.setFieldValue("phoneNumber", "");
    }
  };

  const handleSubmit = async (values, { resetForm }) => {
    const { phoneNumber, password, IsEmail } = values;
    const userObj = {
      password: password,
    };

    //=========== this is for when user save the the email or phone number ========

    const CheckisValidEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };
    // Function to extract the phone number from IsEmail

    if (!CheckisValidEmail(IsEmail) && /\d/.test(IsEmail)) {
      const extractedNumbers = IsEmail.match(/\d+/g);

      const phoneNumberString = extractedNumbers.join(" ");
      const phoneNumberWithoutSpaces = phoneNumberString.replace(/\s/g, "");
      const updatedIsEmail = IsEmail.replace(/\d+/g, "")
        .replace(/\+/g, "") // Remove '+' signs as well
        .replace(/\s+/g, " ")
        .trim();
      const updatedPhoneNumber = `${phoneNumber} ${phoneNumberWithoutSpaces}`;
      // const updatedValues = {
      //   ...values,
      //   phoneNumber: updatedPhoneNumber.trim(),
      //   IsEmail: updatedIsEmail,
      // };

      if (
        updatedIsEmail !== "" &&
        updatedIsEmail !== null &&
        phoneNumber === ""
      ) {
        userObj.email = updatedIsEmail;
      } else {
        userObj.phone_number = updatedPhoneNumber.trim();
      }
    } else {
      if (IsEmail.trim()) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValidEmail = emailRegex.test(IsEmail);
        if (!isValidEmail) {
          toast.error("Invalid email format");
          return;
        }
      }
      if (phoneNumber !== undefined && phoneNumber !== "") {
        const isValid = isValidPhoneNumber(phoneNumber);
        if (!isValid) {
          SetPhoneError(true);
          toast.error("Invalid phone number");
          return;
        }
      }

      if (IsEmail !== "" && IsEmail !== null && phoneNumber === "") {
        userObj.email = IsEmail;
      } else {
        userObj.phone_number = phoneNumber;
      }
    }
    //=========== End this is for when user save the the email or phone number ========

    try {
      setLoading(true);
      const resp = await httpRequest.post(SIGNIN, {
        user: userObj,
      });
      if (resp?.status === 200) {
        const { user } = resp?.data;
        resetForm();
        if (resp?.data?.message === "Success") {
          if (resp?.data?.user?.role === "user") {
            dispatch(loginSuccess(user));
            navigate("/delivery-home");
          }
        } else {
          toast.success("An email sent to you for verification.");
          if (IsEmail !== "" && IsEmail !== null && phoneNumber === "") {
            navigate(`/verification?email=${values.IsEmail}`);
          } else {
            navigate(`/verification?phone=${values.phoneNumber}`);
          }
        }
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        (error?.response?.data?.message || "Something went wrong").replace(
          "Validation failed: ",
          ""
        )
      );
      setLoading(false);
    }
  };
  const LoginwithFacebook = async () => {
    try {
      setIsLoadingFacebook(true);
      const response = await handleFacebookLogin();

      if (response) {
        const resp = await SocialLoginApi({
          provider: "facebook",
          access_token: response?._tokenResponse?.oauthAccessToken,
          user: {
            email: response?._tokenResponse?.email,
            name: response?._tokenResponse?.displayName,
          },
        });

        if (resp.status === 200 && resp?.data?.message === "Success") {
          const user = resp?.data?.user;
          dispatch(loginSuccess(user));
          if (
            user?.user_type === null &&
            user?.status === "pending" &&
            user?.review_approved === false
          ) {
            navigate("/customer-type");
          } else if (
            user?.user_type !== null &&
            user?.status === "pending" &&
            user?.review_approved === false
          ) {
            navigate("/pending-appproval");
          } else if (
            user?.user_type !== null &&
            user?.status !== "pending" &&
            user?.review_approved
          ) {
            navigate("/delivery-home");
          }
        }
      }
    } catch (error) {
      toast.error(error || "Something went wrong");
    } finally {
      setIsLoadingFacebook(false);
    }
  };
  const LoginwithGoogleHandler = async () => {
    try {
      setIsLoadingGoogle(true);
      const response = await HandleGoogleLogin();

      if (response) {
        const resp = await SocialLoginApi({
          provider: "google",
          access_token: response?.user?.accessToken,
        });

        if (resp.status === 200 && resp?.data?.message === "Success") {
          const user = resp?.data?.user;
          dispatch(loginSuccess(user));
          if (
            user?.user_type === null &&
            user?.status === "pending" &&
            user?.review_approved === false
          ) {
            navigate("/customer-type");
          } else if (
            user?.user_type !== null &&
            user?.status === "pending" &&
            user?.review_approved === false
          ) {
            navigate("/pending-appproval");
          } else if (
            user?.user_type !== null &&
            user?.status !== "pending" &&
            user?.review_approved
          ) {
            navigate("/delivery-home");
          }
        }
      }
    } catch (error) {
      toast.error(error || "Something went wrong");
    } finally {
      setIsLoadingGoogle(false);
    }
  };
  return (
    <>
      <Container maxWidth="lg">
        <AuthLayout>
          <Formik
            initialValues={{
              phoneNumber: "",
              password: "",
              IsEmail: "",
            }}
            validationSchema={LoginvalidationSchema}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form autocomplete="off">
                {IsItEmail ? (
                  <>
                    <CustomLabel>
                      What's your phone number or email?
                    </CustomLabel>
                    <PhoneInputsMain
                      className={
                        formik.touched.IsEmail &&
                        formik.errors.IsEmail &&
                        "is__error"
                      }
                    >
                      <Field
                        type="email"
                        name="IsEmail"
                        label="What's your phone number or email?"
                        placeholder="Enter phone number or email"
                      >
                        {({ field, form }) => (
                          <input
                            {...field}
                            onChange={(event) =>
                              EmailOnChange(event.target.value, form)
                            }
                            placeholder="Enter phone number or email"
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="IsEmail"
                        component="span"
                        className="error"
                      />
                    </PhoneInputsMain>
                  </>
                ) : (
                  <PhoneInputsMain
                    className={
                      formik.touched.phoneNumber &&
                      formik.errors.phoneNumber &&
                      "is__error"
                    }
                  >
                    <CustomLabel>
                      What's your phone number or email?
                    </CustomLabel>
                    <Field name="phoneNumber">
                      {({ field, form }) => (
                        <CommonPhoneInputs
                          // {...field}

                          onChange={(value, event) =>
                            handleChange(value, event, form)
                          }
                          value={formik.values.phoneNumber}
                          ref={PhoneInputFoucs}
                        />
                      )}
                    </Field>

                    <ErrorMessage
                      name="phoneNumber"
                      component="span"
                      className="error"
                    />
                  </PhoneInputsMain>
                )}

                <Field
                  type="password"
                  name="password"
                  label="Password"
                  component={AuthInput}
                  placeholder="Enter your password"
                  maxLength={10}
                  showIcon={true}
                  autoComplete="off"
                />

                <ForgotPassword to="/forgot-password">
                  Forgot Password?
                </ForgotPassword>
                {/* {PhoneError && (
                  <span
                    className="Phoneerror"
                    style={{ paddingLeft: "10px", color: "red" }}
                  >
                    Invalid phone number
                  </span>
                )} */}
                <MainButton type="submit" label="Sign In" isLoading={Loading} />
              </Form>
            )}
          </Formik>
          <HorizontalLine />
          <OrText>OR</OrText>
          <OAuthButton
            label="Sign In with Google"
            imageUrl={GoogleIcon}
            onClick={LoginwithGoogleHandler}
            isLoading={isLoadingGoogle}
          />
          <OAuthButton
            label="Sign In with Facebook"
            imageUrl={facebookIcon}
            onClick={LoginwithFacebook}
            isLoading={isLoadingFacebook}
          />
        </AuthLayout>
      </Container>
    </>
  );
};

export default Login;
